const P = process.env.PUBLIC_URL || "";

/** 空间认证标签：粉色 V 图标 + 文案 */
export function SpaceHomeCertLabel(props: { name: string }) {
  const text = props.name.trim();
  if (!text) {
    return null;
  }
  return (
    <span className="space-home-cert">
      <img
        src={`${P}/icons/verified.svg`}
        className="space-home-cert-icon"
        alt=""
        aria-hidden
      />
      {text}
    </span>
  );
}
